import { Button } from "ui-components/button";
import { Heading } from "ui-components/heading";
import { Text } from "ui-components/text";
import { useRouteError } from "react-router";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";

export const ErrorBoundary = () => {
  const error = useRouteError();
  console.error(error);
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="max-w-md text-center">
        <Heading level={1} className="mb-4">
          Oops! Something went wrong
        </Heading>
        <Text type="paragraph" className="mb-6 text-zinc-600 dark:text-zinc-400">
          {"An unexpected error occurred"}
        </Text>
        <Button href="/">Return to Home</Button>
      </div>
    </div>
  );
};
